import { setError } from '../App/ErrorsActions';
import throttle from '../../util/throttle';
import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const ERROR = 'CFD_ERROR';
export const LOADING = 'CFD_LOADING';
export const SUCCESS = 'CFD_SUCCESS';
export const SUCCESS_STATS = 'CFD_SUCCESS_STATS';
export const CLEAR = 'CFD_CLEAR';

const throttledGetData = throttle(_getData, 500);

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data, wip) {
  return {
    type: SUCCESS,
    data,
    wip
  };
}

export function successStats(stats, arrivalDepTrends) {
  return {
    type: SUCCESS_STATS,
    stats,
    arrivalDepTrends
  };
}

export function clearData() {
  return {
    type: CLEAR,
    isLoading: true,
    success: false,
    data: [],
    wip: [],
    stats: undefined,
    arrivalDepTrends: undefined
  };
}

export function getData() {
  return (dispatch, getState) => {
    throttledGetData(dispatch, getState);
  };
}

async function _getData(dispatch, getState) {
  dispatch(isLoading(true));

  const { selected } = getState().dashboards;
  const { data } = getState().app;
  const { user } = getState().auth;

  const allFilters = getState().filters;
  const { chart, allCustomFields, dates } = allFilters;
  const filters = chart === 'overview' ? allFilters.overview : allFilters.cfd;

  const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

  const service = new CalculationsWorker();
  let worker = service.wrap();
  worker = await new worker(selected, data, undefined, {
    isCsv: selected.isCsv,
    enableDoneFilters: user.config.enableDoneFilters,
    enableUnmappedListsActivities: user.config.enableUnmappedListsActivities
  });
  try {
    const cfdData = await worker.CFD({
      from: dates.startDate.toISOString(),
      to: dates.endDate.toISOString(),
      lists: filters.selectedLists,
      labels: filters.selectedLabels,
      members: filters.selectedMembers,
      customFields,
      skipCardDetails: true
    });

    const wip = _.filter(cfdData, item => {
      return _.indexOf(selected.todo, item.listId) > -1 || _.indexOf(selected.wip, item.listId) > -1;
    });
    dispatch(success(cfdData, wip));
  } catch (err) {
    dispatch(setError(err));
  }
}

export function getStats(from, to, cfdData) {
  return async (dispatch, getState) => {
    const { selected } = getState().dashboards;
    const { data } = getState().app;
    const { user } = getState().auth;

    const allFilters = getState().filters;
    const { chart, allCustomFields, excludeWeekends, workStart, workEnd, holidays } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : allFilters.cfd;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, undefined, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableUnmappedListsActivities: user.config.enableUnmappedListsActivities
    });
    try {
      const stats = await worker.CalculateCfdStats({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        customFields,
        from,
        to,
        data: cfdData //mapData(cfdData, data.lists, filters.selectedLists)
      });

      const arrivalDepTrends = await worker.CalculateArrivalDepartureTrends({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        customFields,
        from,
        to
      });

      dispatch(successStats(stats, arrivalDepTrends));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function mapData(cfd, lists, selectedLists) {
  return _(selectedLists)
    .orderBy('order')
    .map(l => {
      const list = _.find(lists, { _id: l._id });
      if (!list) {
        return null;
      }

      const listData = _.find(cfd, { listId: l._id });
      return {
        name: list.name,
        listId: l._id,
        data: listData ? listData.data : []
      };
    })
    .filter(d => !!d)
    .value();
}
